import ClientFile from '../../features/ClientFile';

export default function PortalPage() {
    return <>
        <ClientFile />
    </>;
}
